module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Illustrations"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('b', [_vm._v("Illustrations")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 8th Duke of Hamilton (centre) with Dr Moore (left) and the young John Moore (right)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sir John Moore by Sir Thomas Lawrence")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monument to Sir John Moore in Glasgow")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle of Alexandria")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sir Ralph Abercromby")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Pitt the Younger")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pasquale Paoli")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gilbert Elliot, 1st Earl of Minto")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Admiral Samuel Hood")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frederick, Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Canning")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Viscount Castlereagh")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shorncliffe Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Shorncliffe Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sir David Baird")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British troops on the retreat to Corunna")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nicolas Jean-de-Dieu Soult")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arthur Wellesley, 1st Duke of Wellington")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sir John Moore receives his death wound")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sir John Moore’s tomb at Corunna")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Gallery#plate_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monument to Sir John Moore, St Paul’s Cathedral, London")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d762d6aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Illustrations.vue
// module id = 81
// module chunks = 0